<div class="page-with-sidenav">
  <nav class="page-sidenav-container">
    <md-sidenav [parentRoute]="'pricing'"></md-sidenav>
  </nav>
  <div class="page-content">
    <router-outlet></router-outlet>
  </div>
</div>
